import React from 'react';
import { useTranslation } from 'react-i18next';
import { isOnlinePosting, isPortalWithoutArchiveOption } from '@panel/commons/helpers';
import { sendTrackingInfo } from '@panel/commons';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import { userInfoSelectors } from '@panel/core/src/state/ducks/user';
import { useSelector } from 'react-redux';
import { BulkActionIcon, BulkActionIconContainer, BulkActionContainer, BulkActionText } from '../styles';

const Archive = ({ postings, setBulkActionsModals, bulkActionsModals, device }) => {
  const { t } = useTranslation();
  const { publisherTypeId } = useSelector(userInfoSelectors.getuserInfoState);
  const isParticular = publisherTypeId === '1';
  const forbiddenStates = ['DELETED'];
  const isPostingWithoutArchiveOp =
    isPortalWithoutArchiveOption() && postings.some(p => p.checked && isOnlinePosting(p.stateAndDates[0].status));

  const archiveAvailable =
    postings &&
    postings.some(p => p.checked) &&
    !postings.some(p => p.checked && forbiddenStates.some(state => state === p.stateAndDates[0].status)) &&
    !isPostingWithoutArchiveOp;

  const postingsToArchive = archiveAvailable
    ? postings.reduce((archiveArray, currentPosting) => {
        if (currentPosting.checked && !currentPosting.postingFull) archiveArray.push(currentPosting.postingId);
        return archiveArray;
      }, [])
    : [];

  const includesOnlinePostings =
    archiveAvailable &&
    postings.some(posting => {
      const status = posting.stateAndDates[0] && posting.stateAndDates[0].status;
      const onlineStates = ['ONLINE', 'NEAR_END'];
      const isOnline = onlineStates.includes(status);
      return isOnline && posting.checked;
    });

  // En el caso de seleccionar postings online y offline,
  // filtro los posintings onlinne para saber si tienen leads sin responder.
  const onlinePostingsListToArchive =
    postings && archiveAvailable && includesOnlinePostings
      ? postings.reduce((archiveArray, currentPosting) => {
          if (currentPosting.checked && isOnlinePosting(currentPosting.stateAndDates[0].status))
            archiveArray.push(currentPosting.postingId);
          return archiveArray;
        }, [])
      : [];

  const particularNotFree =
    archiveAvailable &&
    isParticular &&
    postings.some(p => p.checked && p.publicationPlan && !p.publicationPlan.includes('FREE'));

  if (archiveAvailable) {
    return (
      <BulkActionContainer
        onClick={() => {
          setBulkActionsModals({
            ...bulkActionsModals,
            archive: {
              open: true,
              postingList: postingsToArchive,
              includesOnlinePostings,
              particularNotFree,
              onlinePostingsList: onlinePostingsListToArchive
            }
          });
          sendTrackingInfo('Panel', 'Mis avisos', 'Bulk-Archivar');
        }}
        className='insideSelector'
      >
        <SimpleTooltip
          isMobile={device === 'tablet'}
          position='top-center'
          text={t('panel.bar.select.actions.archive')}
        >
          <BulkActionIconContainer device={device}>
            <BulkActionIcon action='archive' />
          </BulkActionIconContainer>
        </SimpleTooltip>
        {device === 'tablet' && <BulkActionText>{t('panel.bar.select.actions.archive')}</BulkActionText>}
      </BulkActionContainer>
    );
  }
  return null;
};

export default Archive;
